import styled from 'styled-components';

export const Container = styled.section`
  font-family: 'Work Sans', Arial, Helvetica, sans-serif;

  header h1 {
    font-weight: 600;
    color: ${({ theme }) => theme.colors.grayDark3};
    font-family: 'Source Sans Pro';
    margin-bottom: 1rem;
    font-size: 3rem;
  }

  header span {
    color: ${({ theme }) => theme.colors.grayDark4};
  }

  & > header {
    padding: 1.5rem;

    & > div {
      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        max-width: ${({ theme }) => theme.breakpoints.laptopL};
      }
    }
  }

  & .cards {
    width: 100%;
    padding: 1.5rem 0;
    background-color: #efefef;

    & .cards-container {
      display: flex;
      flex-wrap: wrap;
      row-gap: 1.5rem;
      column-gap: 1.5rem;
      width: 97%;
      margin: 1rem auto 1rem auto;

      & > .card {
        width: 100%;

        & > .hefesto-card {
          height: 100%;

          & > .hefesto-card-text-buttons {
            display: flex;
            flex-direction: column;
            height: 100%;

            & > .hefesto-card-text-buttons__description {
              flex-grow: 1;
            }
          }
        }
      }

      p {
        min-height: 75px;
      }

      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        max-width: ${({ theme }) => theme.breakpoints.laptopL};
      }

      @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        justify-content: space-between;
        flex-wrap: nowrap;
        column-gap: 1.5rem;

        & > .card {
          width: 50%;
        }
      }
    }
  }
`;
